import { IconButton } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import InfoOutlined from '@material-ui/icons/InfoOutlined'
import clsx from 'clsx'
import React, { useContext } from 'react'

import TicketVariantContext, { TicketVariant } from '../../lib/TicketVariantContext'
import Popover from '../popover/Popover'
import { Body2, Subtitle } from '../utils/typography'
import BenefitItem, { BenefitItemProps } from './BenefitItem'

const useStyles = makeStyles(theme => ({
  icon: {
    '&$standard': {
      color: theme.palette.grey[500],
    },
    color: 'inherit',
    fontSize: '1.25rem',
    padding: 0,
  },
  root: {
    alignItems: 'center',
    display: 'flex',
  },
  standard: {},
  title: {
    alignSelf: 'center',
    flex: 1,
  },
}))

export type BenefitDescriptionItemProps = BenefitItemProps & {
  detail?: string | null
  title: string
}

const BenefitDescriptionItem = ({
  title,
  detail,
  className,
  ...rest
}: BenefitDescriptionItemProps) => {
  const { variant } = useContext(TicketVariantContext)
  const classes = useStyles()

  return (
    <BenefitItem className={clsx(classes.root, className)} {...rest}>
      <Body2 className={classes.title} color="inherit">
        {title}
      </Body2>
      {detail && (
        <Popover
          placement="right"
          trigger={
            <IconButton
              aria-label="Info"
              className={clsx(classes.icon, {
                [classes.standard]: variant === TicketVariant.Standard,
              })}
            >
              <InfoOutlined fontSize="inherit" />
            </IconButton>
          }
        >
          <Subtitle>{detail}</Subtitle>
        </Popover>
      )}
    </BenefitItem>
  )
}

export default BenefitDescriptionItem
